// extracted by mini-css-extract-plugin
module.exports = {"handles":"SocialHandles_handles__t7Ncv","logo":"SocialHandles_logo__DpeCb"};